module.exports = __webpack_public_path__ + "assets/b_diners-club-a8dfcf.svg";